import { useQuery, NetworkStatus } from "@apollo/client";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import useTitle from "hooks/useTitle";
import Box from "ds/components/Box";
import Card from "ds/components/Card";

import RuntimeSecurityPageLayout from "./PageLayout";
import WorkerPoolRunnerImagesForm from "./Form";
import { GET_ACCOUNT_DEFAULT_RUNNER_IMAGES } from "./gql";
import RuntimeSecuritySkeleton from "./RuntimeSecuritySkeleton";

type AccountDefaultRunnerImages = {
  defaultPublicWorkerPoolRunnerImage?: string;
  defaultPrivateWorkerPoolRunnerImage?: string;
};

const RuntimeSecurity = () => {
  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Organization Settings · Runtime Security · ${accountName}`);

  const { loading, data, networkStatus } = useQuery<AccountDefaultRunnerImages>(
    GET_ACCOUNT_DEFAULT_RUNNER_IMAGES
  );

  if (loading && networkStatus != NetworkStatus.refetch) {
    return <RuntimeSecuritySkeleton />;
  }

  return (
    <RuntimeSecurityPageLayout>
      <Box direction="column" limitWidth="medium" gap="x-large" fullWidth>
        <Card titleTag="h3" title="Default runner image">
          <Box direction="column" padding="small 0 0" fullWidth>
            <WorkerPoolRunnerImagesForm
              defaultPublicWorkerPoolRunnerImage={data?.defaultPublicWorkerPoolRunnerImage}
              defaultPrivateWorkerPoolRunnerImage={data?.defaultPrivateWorkerPoolRunnerImage}
            />
          </Box>
        </Card>
      </Box>
    </RuntimeSecurityPageLayout>
  );
};

export default RuntimeSecurity;
